import { Stack, Typography } from "@mui/material";

export const MatrixViewBlock = ({
  isModal,
  accuracy_score,
  expectations_score,
  impression_score,
  business_flows_score,
}: {
  isModal?: boolean;
  accuracy_score: number | null;
  expectations_score: number | null;
  impression_score: number | null;
  business_flows_score: number | null;
}) => {
  const metrix = [
    {
      rate: accuracy_score,
      title: "Analysis Accuracy",
    },
    {
      rate: business_flows_score,
      title: "Business Flow Support",
    },
    {
      rate: expectations_score,
      title: "Meeting Expectations",
    },
    {
      rate: impression_score,
      title: "Overall Impression",
    },
  ];

  return (
    <Stack
      sx={{
        flexDirection: "row",
        padding: "12px 16px",
        border: "1px solid #D9D9D9",
        borderRadius: "8px",
        gap: "16px 40px",
        flexWrap: "wrap",
      }}
    >
      {metrix.map(({ title, rate }) => (
        <Stack
          key={title}
          sx={{
            gap: "8px",
            flex: `1 1 calc(${isModal ? "50% - 40px" : "25% - 120px"})`,
          }}
        >
          <Typography fontSize="13px" lineHeight="15px" color="#4C545B">
            {title}
          </Typography>
          <Typography
            fontSize="13px"
            lineHeight="15px"
            fontWeight={500}
            color="custom.textDarkBlue"
          >
            {rate ? `${rate}/5` : "--"}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
